<h-modal class="align-center no-padding" role="dialog" ariaLabelledby="3DSecureSystem">
    <div h-modal-body>
        <h2
            i18n
            id="3DSecureSystem"
            #modalElement
            tabindex="0"
            class="sr-only"
            i18n-aria-label="@@form--hermes-checkout--payment.3ds-reassurance.indroduction-link"
            aria-label="3D Secure system">
            3D Secure system
        </h2>
        <div class="adyen-container">
            <h-redirect-message [state]="state" [errorMessage]="errorMessage"></h-redirect-message>
        </div>
    </div>
</h-modal>
<div class="modal-background"></div>
